// extracted by mini-css-extract-plugin
export var emailBlockLink = "_k5-0";